import { FC, FormEvent, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { Input } from "../ui/input";

interface Props {
  data: any[];
  setData: React.Dispatch<React.SetStateAction<any[]>> | Function;
}

const FinalTable: FC<Props> = ({ data, setData }) => {
  const [totalPrice, setTotalPrice] = useState<number>(0);

  useEffect(() => {
    const total = data.reduce((acc, item) => acc + (item.value || 0), 0);
    setTotalPrice(total);
  }, [data]);

  return (
    <div className="mt-5 max-h-96 overflow-y-auto w-full">
      {data && data.length > 0 && (
        <Table className="min-w-full table-auto">
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead className="text-right pr-8">Price($)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className="w-full">
            {data &&
              data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="w-full text-left">
                    {item.name}
                  </TableCell>
                  <TableCell>
                    <Input
                      min={1}
                      className="w-20 text-right"
                      onChange={(e: FormEvent<HTMLInputElement>) =>
                        setData((prev: any[]) =>
                          prev.map((i) =>
                            i.id === item.id
                              ? { ...i, value: +e.currentTarget.value }
                              : i,
                          ),
                        )
                      }
                      id={item.name}
                      type="number"
                      value={item.value || ""}
                      required
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          <TableFooter className="sticky bottom-0">
            <TableRow>
              <TableCell className="">Total</TableCell>
              <TableCell>
                <Input
                  min={1}
                  className="w-20 text-right"
                  id="total"
                  type="text"
                  value={totalPrice + "$"}
                  readOnly
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      )}
    </div>
  );
};

export default FinalTable;
